import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { AttachSession } from 'protractor/built/driverProviders';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-business-type-wise-product-commission-trace-log',
  templateUrl: './business-type-wise-product-commission-trace-log.component.html',
  styleUrls: ['./business-type-wise-product-commission-trace-log.component.scss']
})
export class BusinessTypeWiseProductCommissionTraceLogComponent implements OnInit {
  dataSource: Object;

  constructor(private http: HttpService, private global: GlobalService) {
    this.global.set_master_page_title = 'Booth Agent Commission Trace';
    this.http.getBusinessTypeWiseProductCommissionTraceLog().subscribe((data)=> {
      this.dataSource = data
    })
   }

  ngOnInit() {
  }

}
